import logo from '../../assets/aakash-logo.png'
import styles from './LoginLhs.module.css'

const LoginLhs = () => {
    let exam_type =
        (window.location.hostname === "akthedashboard-qa.aakash.ac.in" ||
            window.location.hostname === "akthedashboard.aakash.ac.in")
            ? "AKTHE"
            : "ANTHE";
    return (
        <div className={`${styles.lhsWrapper} col-md-6`}>
            <div className={styles.login1}>
                <div className={styles.welcome}>
                    <p>Welcome to</p>
                    <p>aakash</p>
                    <img src={logo} className={styles.logo} alt="Aakash logo" />
                    <p className={styles.lhsText}>
                        A Scholarship exam for Class { exam_type == 'AKTHE'? '7th':'5th'} to 12th & 12th Passed Students
                    </p>
                </div>
            </div>
        </div>
    )
}

export default LoginLhs
